import {
  type QueryClient,
  useQuery,
  type UseQueryOptions,
} from '@tanstack/react-query';
import { StatusCode, type CustomerProductRating } from '@hungryroot/rest';
import {
  getApiV2CustomersSelfProductRatingsId,
  type Params,
} from '@hungryroot/rest/api/v2/customers/self/product_ratings/[id]/get';

type UseSelfProductRatingProps = {
  params: Params;
  options?: Omit<
    UseQueryOptions<CustomerProductRating>,
    'queryFn' | 'queryKey'
  >;
};

export function getQueryKey({ id }: Params) {
  return ['Customer', 'Product Rating', { id }];
}

export function invalidateQuery({
  id,
  queryClient,
}: Pick<Params, 'id'> & { queryClient: QueryClient }) {
  queryClient.invalidateQueries({
    queryKey: getQueryKey({ id }),
  });
}

export function useSelfProductRating(props: UseSelfProductRatingProps) {
  const { params, options } = props;

  return useQuery({
    queryKey: getQueryKey(params),
    queryFn: async () => {
      const res = await getApiV2CustomersSelfProductRatingsId(params);

      if (res.status !== StatusCode.SuccessOK) {
        throw new Error(JSON.stringify(res.data, null, 2));
      }

      return res.data;
    },
    ...options,
  });
}
